// The leaf, not the wizard's barrel: that barrel mounts the steps, which render
// this feature's screens — importing it here would close the loop.
import { CodeToPath, StepCodes, WIZARD_STEPS_PATH } from '../integrationWizard/steps';

const VIEW_PARAM = 'view';
const GUIDES_VIEW = 'guides';

const GUIDES_PATHNAME = `${WIZARD_STEPS_PATH}/${CodeToPath[StepCodes.Integrate]}`;

export type GuidesLocation = { pathname: string; search: string };

/**
 * Where the beta's "use the guides instead" controls go.
 *
 * A view of the integration step rather than a prop threaded down to every leaf
 * screen, so the guides survive a reload and the back button reaches them.
 *
 * Built from the search the customer already has: on a second device the
 * flow's `?domain=` is the only handle on the running setup, and replacing the
 * whole query string would strand them on the entry screen.
 */
export function guidesLocation(search: string): GuidesLocation {
  const params = new URLSearchParams(search);
  params.set(VIEW_PARAM, GUIDES_VIEW);

  return { pathname: GUIDES_PATHNAME, search: `?${params}` };
}

export function leaveGuidesLocation(search: string): GuidesLocation {
  const params = new URLSearchParams(search);
  params.delete(VIEW_PARAM);
  const rest = params.toString();

  return { pathname: GUIDES_PATHNAME, search: rest ? `?${rest}` : '' };
}

export function isGuidesView(search: string): boolean {
  return new URLSearchParams(search).get(VIEW_PARAM) === GUIDES_VIEW;
}
